import { memo } from 'react'
import clsx from 'clsx'
import { APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES } from 'src/config/request/hotClubHttp'
import { useHotRequest } from '@hotmart-org-ca/hot-club-http/client/hooks'
import { PublicationEndpoints } from 'src/client/publication/constants'
import { IMAGES } from 'src/assets'
import { UrlHelper } from 'src/utils/url'
import { Embed } from '../embed'
import Loading from '../Loading'
import { PlayerProps, VideoProps } from './player.types'
import { Wrapper } from './player.styles'
import { REQUEST_CONFIG } from './player.constants'

const Player = ({ id, className, playerConfig }: PlayerProps) => {
  const endpoint = PublicationEndpoints.getMedia(id)
  const queryParams = playerConfig ? UrlHelper.toQueryString(playerConfig) : ''
  const allow =
    playerConfig && 'autoplay' in playerConfig ? 'autoplay; encrypted-media' : 'encrypted-media'

  const { data, isLoading, isError } = useHotRequest<VideoProps>(endpoint, {
    cacheKey: [endpoint],
    instanceName: APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_SPARKLE,
    queryOptions: {
      ...REQUEST_CONFIG
    }
  })

  const getVideoSrc = () => {
    if (isError) {
      return IMAGES.NO_VIDEO
    }

    return playerConfig ? `${data?.url}&${queryParams}` : data?.url || IMAGES.NO_VIDEO
  }

  if (isLoading) {
    return (
      <Wrapper
        className={clsx(
          '_w-full _mt-3 _d-flex _align-items-center _justify-content-center',
          className
        )}
      >
        <Loading full />
      </Wrapper>
    )
  }

  return (
    <div className={className}>
      <Embed size="16by9" className="_bg-gray-100">
        {({ embedItemClassName }) => (
          <iframe
            allowFullScreen
            title="player"
            src={getVideoSrc()}
            frameBorder="0"
            role="application"
            allow={allow}
            className={clsx('_w-full', embedItemClassName)}
            onError={
              /* istanbul ignore next */ ({ currentTarget }) => {
                currentTarget.onerror = null
                currentTarget.src = IMAGES.NO_VIDEO
              }
            }
          />
        )}
      </Embed>
    </div>
  )
}

export default memo(Player)
